module.exports = __webpack_public_path__ + "img/clients.3cb4b323.svg";